import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFeedbackIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1056_11195",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1056_11195)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12 6.6155C12.1808 6.6155 12.3286 6.55808 12.4433 6.44325C12.5581 6.32858 12.6155 6.18083 12.6155 6C12.6155 5.81917 12.5581 5.67142 12.4433 5.55675C12.3286 5.44192 12.1808 5.3845 12 5.3845C11.8192 5.3845 11.6714 5.44192 11.5568 5.55675C11.4419 5.67142 11.3845 5.81917 11.3845 6C11.3845 6.18083 11.4419 6.32858 11.5568 6.44325C11.6714 6.55808 11.8192 6.6155 12 6.6155ZM11.5 14.423H12.5V8.34625H11.5V14.423ZM3 20.077V4.6155C3 4.15517 3.15417 3.77083 3.4625 3.4625C3.77083 3.15417 4.15517 3 4.6155 3H19.3845C19.8448 3 20.2292 3.15417 20.5375 3.4625C20.8458 3.77083 21 4.15517 21 4.6155V15.3845C21 15.8448 20.8458 16.2292 20.5375 16.5375C20.2292 16.8458 19.8448 17 19.3845 17H6.077L3 20.077ZM5.65 16H19.3845C19.5385 16 19.6796 15.9359 19.8078 15.8078C19.9359 15.6796 20 15.5385 20 15.3845V4.6155C20 4.4615 19.9359 4.32042 19.8078 4.19225C19.6796 4.06408 19.5385 4 19.3845 4H4.6155C4.4615 4 4.32042 4.06408 4.19225 4.19225C4.06408 4.32042 4 4.4615 4 4.6155V17.6443L5.65 16Z",
				fill: "#808282"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgFeedbackIcon);
export { ForwardRef as ReactComponent };
